<template>
  <div v-if="!isLogged" class="min-h-screen bg-gray-100 text-gray-900 flex justify-content-center">
    <div  class="max-width-xl m-0 sm:m-8 bg-white shadow sm:border-round-lg flex align-content-center justify-content-center flex-wrap">
         <router-view /> 
    </div>
  </div>
  <div :class="containerClass" @click="onWrapperClick" v-if="isLogged">
    <AppTopBar v-bind:gRuta="ruta" @menu-toggle="onMenuToggle" />

    <transition name="layout-sidebar">
      <div
        :class="sidebarClass"
        @click="onSidebarClick"
        v-show="isSidebarVisible()"
      >
        <div class="layout-logo">
          <router-link to="/">
            <img alt="Logo" src="assets/layout/images/logo.png" />
          </router-link>
        </div>
        <AppProfile v-bind:gNameuser="username"/>
        <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
      </div>
    </transition>
    <div class="layout-main">
      <router-view />
    </div>
    <AppFooter />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppTopBar from "./AppTopbar.vue";
import AppProfile from "./AppProfile.vue";
import AppMenu from "./AppMenu.vue";
import AppFooter from "./AppFooter.vue";

export default {
  data() {
    return {
      
      layoutMode: "static",
      layoutColorMode: "light",
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      modoNormal:false,
      ruta:'Inicio',
      inventarios : false,
      username:'',

      menu: [
        {
          label:"Sistema",
          
          icon:"pi pi-fw pi-home",
          items:[
            {
              label: "Lista empresas",
              icon: "material_home_work",
              to: "/empresas"
            },
            {
              label: "Configuración",
              icon: "material_settings",
              to: "/configuracion"
            }
              
          ]
        },
        {
          label: "Catalogos",
          icon: "pi pi-fw pi-table",
          items: [
            {
              label: "Cuentas",
              icon: "material_lists",
              to: "/cuentas",
            },
            { label: "Cuentas a RFC", icon: "material_user_attributes", to: "/cuentasrfc",  },
            
            {
              label: "Tipos de Pólizas",
              icon: "material_event_list",
              to: "/tipopoliza",
            },
            {
              label: "Plantillas de Pólizas",
              icon: "material_design_services",
              to: "/polizasplantillas",

            }
          ],
        },
        {
          label: "Movimientos",
          icon: "pi pi-fw pi-sync",
          
          items: [
            {
              label: "Captura de Pólizas",
              icon: "material_edit_document",
              to: "/poliza",
            },
            {
              label: "Listado de Pólizas",
              icon: "material_list_alt",
              to: "/polizas",
            },
            {
              label: "Saldos de cuentas",
              icon: "material_list_alt",
              to: "/saldoscuenta",
            },
            {
              label: "Saldos iniciales",
              icon: "material_grading",
              to: "/saldoscuentas",
            },
            {
              label: "Contabilidad electrónica",
              icon: "material_data_table",
              to: "/contabilidadelectronica",
            },
            {
              label: "Ejercicios",
              icon: "material_two_pager",
              to: "/ejercicios",
            },

            { label: "Inventarios", icon: "pi pi-fw pi-check-square", to: "/inventarios", visible: this.isInventarios() },
          ],
        },
        
        {
          label: "CFDIS",
          icon: "pi pi-fw pi-qrcode",
          items: [
            {
              label: "Listado de CFDI",
              icon: "material_snippet_folder",
              to: "/cfdis",
            },
            {
              label: "Listado de CFDI PPD",
              icon: "material_work_history",
              to: "/listacfdippd",
            },
            {
              label: "Agregar archivos xml de CFDI",
              icon: "material_qr_code_2_add",
              to: "/cfdisadd",
            },
            {
              label: "Descargar CFDI (Portal del SAT)",
              icon: "material_desktop_cloud",
              to: "/cfdidescarga",
            },
            {
              label: "Descarga WebService SAT",
              icon: "material_cloud_download",
              to: "/cfdidescargaws",
            },
            {
              label: "Configuración de FIEL",
              icon: "material_settings_b_roll",
              to: "/cfdisconfig",
            },
            {
              label: "DIOT 2025",
              icon: "material_settings_b_roll",
              to: "/diotperiodos",
            },
           
          ],
        },
        {
          label: "Reportes",
          icon: "pi pi-fw pi-book",
          items: [
            {
              label: "Estado de Situación Financiera",
              icon: "material_account_balance",
              to: "/repbalance"
            },
            { label: "Estado de Resultados", 
              icon: "material_trending_up",
              to: "/represultados"
            },
            {
              label: "Balanza de Comprobación",
              icon: "material_balance",
              to: "/repbalanza"
            },
            
            { label: "Auxiliar de Cuentas", icon: "material_table_view", to: "/repauxiliar" },
            { label: "Diario de Pólizas", icon: "material_note_stack", to: "/repdiario" },
            { label: "Flujos de Efectivo", icon: "material_account_balance_wallet", to: "#" },
            { label: "Estado de Cambios en el Capital Contable", icon: "material_desktop_landscape", to: "#" },
            
          ],
        },
        {
          label: "Bancos",
          icon: "pi pi-fw pi-wallet",
          items: [
            {
              label: "Cuentas Bancarias",
              icon: "pi pi-fw pi-id-card",
              to: "/cuentasbancarias",
              id: "bancos_cuentasbancarias_menu",
              
            },
            { label: "Movimientos Bancarios", 
              icon: "pi pi-fw pi-money-bill",
              to: "/movbancos",
              id: "bancos_movimientosbancarios_menu",
            },
          ]
        },
        {
          label: "Utilerias",
          icon: "pi pi-fw pi-wrench",
          items: [
            {
              label: "Restructuración de Saldos",
              icon: "material_currency_exchange",
              to: "/rsaldos",
              
              
            }
            
          ]
        },
      ],
    };
  },

  computed: {
    ...mapGetters(["isLogged"]),


    containerClass() {
      return [
        "layout-wrapper",
        {
          "layout-overlay": this.layoutMode === "overlay",
          "layout-static": this.layoutMode === "static",
          "layout-static-sidebar-inactive":
            this.staticMenuInactive && this.layoutMode === "static",
          "layout-overlay-sidebar-active":
            this.overlayMenuActive && this.layoutMode === "overlay",
          "layout-mobile-sidebar-active": this.mobileMenuActive,
        },
      ];
    },
    sidebarClass() {
      return [
        "layout-sidebar",
        {
          "layout-sidebar-dark": this.layoutColorMode === "dark",
          "layout-sidebar-light": this.layoutColorMode === "light",
        },
      ];
    },
    logo() {
      return this.layoutColorMode === "dark"
        ? "assets/layout/images/logo-b.png"
        : "assets/layout/images/logo.png";
    },
    
  },


  created() {
    const userInfo = localStorage.getItem("user");
    const userEmpresa = localStorage.getItem("empresa");
    console.log("creayed");
    console.log("Usuario:" + userInfo);
    if (userInfo) {
      const userData = JSON.parse(userInfo);
      this.$store.commit("setUserData", userData);
      this.username = userData.user.name;
      /*if (this.$store.getters.modulos !== undefined){
          console.log('--consulta modulos app.vue created--');
          console.log(this.$store.getters.modulos);
          this.modulos = this.$store.getters.modulos;
      }*/

    }
    this.keyIndex = 0;
    console.log("Empresa:" + userEmpresa);
    if (userEmpresa) {
      const empresaData = JSON.parse(userEmpresa);
      this.$store.commit("setEmpresaData", empresaData);

      console.log('---sss---ss-----');
      console.log(empresaData.data.configuracion);
      console.log('---sss---ss-----2222222');
      const config = JSON.parse( empresaData.data.configuracion);
      console.log('---sss---ss-----222222333333');
      console.log(config.generales.costoventas);
      this.inventarios = config.generales.costoventas;
      

      //this.inventarios = empresaData.data.configuracion.generales.costoventas =='periodicos';
    }

   
    this.$axios.interceptors.response.use(
      (response) => response,
      (error) => {
        console.log('---intercepcion error---');
        console.log(error);
        if (error.response.status === 401) {
          this.$store.dispatch("logout");
        }
        return Promise.reject(error);
      }
    );
  },

   
  methods: {

   
    

    isInventarios()
    {
      return this.inventarios==='periodicos';
    },
    

    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
      this.menuClick = false;
    },
    onMenuToggle() {
      console.log('aqui entra.....');
      this.menuClick = true;
      if (this.isDesktop()) {
        if (this.layoutMode === "overlay") {
          if (this.mobileMenuActive === true) {
            this.overlayMenuActive = true;
          }
          this.overlayMenuActive = !this.overlayMenuActive;
          this.mobileMenuActive = false;
        } else if (this.layoutMode === "static") {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }
      event.preventDefault();
    },

    onSidebarClick() {

      console.log('---clic sidebar');
      this.menuClick = true;
      
    },

    onMenuItemClick(event) {
      
      if (event.item && !event.item.items) {
        this.ruta = event.item.label;
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      
      }
    },

    addClass(element, className) {
      if (element.classList) element.classList.add(className);
      else element.className += " " + className;
    },
    removeClass(element, className) {
      if (element.classList) element.classList.remove(className);
      else
        element.className = element.className.replace(
          new RegExp(
            "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
            "gi"
          ),
          " "
        );
    },
    isDesktop() {
      console.log('inner width: '+window.innerWidth);
      return window.innerWidth > 1024;
    },
    isSidebarVisible() {

      if (this.isDesktop()) {
        console.log('---esDesktop....');
        if (this.layoutMode === "static") return !this.staticMenuInactive;
        else if (this.layoutMode === "overlay") return this.overlayMenuActive;
        else return true;
      } else {
        return true;
      }
    },
  },
  beforeUpdate() {
    console.log('esto se esta llamado...');
    
    if (this.mobileMenuActive){
      console.log('esto se esta llamado...1');
      this.addClass(document.body, "body-overflow-hidden");
    }      
    else {
      console.log('esto se esta llamado...2');
      this.removeClass(document.body, "body-overflow-hidden");
    }
    
  },
  components: {
    AppTopBar: AppTopBar,
    AppProfile: AppProfile,
    AppMenu: AppMenu,
    AppFooter: AppFooter,
  },
};
</script>

<style>
@import "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined";
@import url('https://fonts.googleapis.com/css2?family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Encode+Sans+Condensed:wght@100;200;300;400;500;600;700;800;900&display=swap');
@import "./App.scss";


.layout-main {
  transition: margin-left 0.2s;
  padding: 60px 10px 0px 10px;
}
.layout-sidebar{
  width: 230px;
}

.font-guest{
   font-family: "Roboto Condensed", sans-serif;
}

.p-paginator {
    background: #ffffff;
    color: #71717A;
    border: solid #f4f4f5;
    border-width: 0;
    padding: 0.25rem 0.25rem;
    border-radius: 0.375rem;
}

.max-width-xl{
max-width: 1280px;
}

@media (min-width: 1201px) {

    .layout-wrapper.layout-static .layout-main, .layout-wrapper.layout-static .layout-footer {
        margin-left: 230px;
    }
}
@media (min-width: 1201px) {

    .layout-wrapper.layout-static .layout-topbar {
        left: 230px;
    }
}
</style>
